import FloatConfigContainer from '../FloatConfigContainer/FloatConfigContainer';
import Button from 'components/Button/Button';
import FloatConfigHeader from '../FloatConfigContainer/FloatConfigHeader/FloatConfigHeader';
import FloatConfigOption from '../FloatConfigContainer/FloatConfigOption/FloatConfigOption';
import { useCallback, useEffect, useState } from 'react';
import { debounce } from 'lodash';
import useStateStore from 'services/store';
import FloatConfigTab from '../FloatConfigContainer/FloatConfigTab/FloatConfigTab';
import { ConfigDataTab, ConfigOption } from 'services/types';
import { deepCopy, quickSort } from 'services/utils';

const Fabric = () => {
    const [seekInput, setSeekInput] = useState('');
    const [seekValue, setSeekValue] = useState('');
    const { activeProductData, activeFabric } = useStateStore();
    const [currentFabrics, setCurrentFabrics] = useState<ConfigOption[]>([]);
    const [fabrics, setFabrics] = useState<ConfigDataTab>();
    useEffect(() => {
        fetch('data/fabrics.json')
            .then((response) => response.json())
            .then((data) => {
                setFabrics(data);
            })
            .catch((error) => {
                console.error('Error fetching fabrics:', error);
            });
    }, []);

    const handleSeek = (value: string) => {
        setSeekValue(value);
    };

    const debounceSeeking = useCallback(
        debounce((nextValue) => handleSeek(nextValue), 1000),
        []
    );

    const handleSeekChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setSeekInput(value);
        debounceSeeking(value);
    };

    useEffect(() => {
        const list: ConfigOption[] = [];
        if (activeProductData?.[activeFabric]?.fabric?.tab! === 'all') {
            if (fabrics) {
                const tabList: string[] = [];
                Object.keys(fabrics).forEach((fab) => {
                    tabList.push(fabrics[fab].id);
                });
                tabList.forEach((tab) => {
                    if (fabrics[tab].data.length > 0) {
                        fabrics[tab].data.forEach((item) => {
                            list.push({ ...deepCopy(item) });
                        });
                        // list.concat([...fabrics[tab].data]);
                    }
                });
            }
        } else {
            fabrics?.[activeProductData?.[activeFabric]?.fabric?.tab!]?.data?.forEach((fab) => {
                if (fab.name.toLowerCase().includes(seekValue.toLowerCase())) {
                    list.push({ ...deepCopy(fab) });
                }
            });
        }
        setCurrentFabrics(quickSort(list));
    }, [seekValue, activeFabric, activeProductData?.[activeFabric]?.fabric?.tab, fabrics]);

    const emptySeek = () => {
        setSeekInput('');
        setSeekValue('');
    };

    return (
        <FloatConfigContainer>
            <FloatConfigHeader />
            <div className="pre-body">
                <FloatConfigTab data={fabrics} />
                <div className="seeking">
                    <div className="seeking-container">
                        <input
                            value={seekInput}
                            onChange={(e) => handleSeekChange(e)}
                            placeholder="Find material, e.g: Royal"
                            className="seek-input"
                            type="text"
                        />
                        <Button>SEEK</Button>
                        <Button onClick={emptySeek} variant="secondary">
                            X
                        </Button>
                    </div>
                </div>
                {/* <div
          style={{
            fontSize: '0.9em',
            padding: '0.5em 0.25em',
            borderBottom: '1px solid lightGray',
            textAlign: 'center',
          }}
          className="announce"
        >
          Select up to 3 materials
        </div> */}
            </div>
            <div className="body">
                <div className="list-container">
                    {currentFabrics.map(
                        (fab) =>
                            (fab.name.toLowerCase().includes(seekValue.toLowerCase()) ||
                                fab.id.toLowerCase().includes(seekValue.toLowerCase())) && (
                                <FloatConfigOption
                                    type="fabric"
                                    key={fab.id}
                                    item={fab}
                                    procedure="changeFabric"
                                />
                            )
                    )}
                </div>
            </div>
        </FloatConfigContainer>
    );
};

export default Fabric;
